import { render, staticRenderFns } from "./TaskSearch copy.vue?vue&type=template&id=f74ed1f0&scoped=true"
import script from "./TaskSearch copy.vue?vue&type=script&lang=js"
export * from "./TaskSearch copy.vue?vue&type=script&lang=js"
import style0 from "./TaskSearch copy.vue?vue&type=style&index=0&id=f74ed1f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74ed1f0",
  null
  
)

export default component.exports